// extracted by mini-css-extract-plugin
module.exports = {"form":"Search_form__1g7je","input":"Search_input__3xE_r","result":"Search_result__3A3-a"};